import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface AvailabilityToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function AvailabilityToggle({
  checked,
  onCheckedChange,
}: AvailabilityToggleProps) {
  const { t } = useTranslation();

  return (
    <div className='flex items-center space-x-2 pt-2'>
      <Switch
        id='available'
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <Label htmlFor='available'>{t('availableOnMenu')}</Label>
    </div>
  );
}
